var _ellipse, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 138,
    viewBox: "0 0 130 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 72.8089,
    rx: 65,
    ry: 65.1907,
    fill: "#D6EBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_227_4091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -58,
    width: 130,
    height: 196
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 72.8089C130 108.813 100.899 138 65 138C29.1015 138 0 108.813 0 72.8089C0 36.8051 29.1015 -57.8701 65 -57.8701C100.899 -57.8701 130 36.8051 130 72.8089Z",
    fill: "#EBF5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_227_4091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7748 79.5367C74.7748 79.5367 84.2722 79.711 88.2848 77.6604C92.2974 75.6097 95.666 72.908 96.9081 69.8269C98.1502 66.7458 98.6614 63.5571 98.6614 63.5571V60.9681L98.2678 48.2541L97.3375 35.9707C97.3375 35.9707 96.4992 27.3632 95.0322 25.3535C93.5651 23.3439 90.0074 19.2016 88.7653 18.5146C87.5232 17.8276 81.6295 14.3057 81.6295 14.3057C81.6295 14.3057 82.0129 16.587 81.4762 17.5867C80.9394 18.5864 79.8047 22.2212 77.668 24.0411C75.5313 25.8611 72.2957 28.0963 69.3565 28.3628C66.4173 28.6294 60.3652 28.4808 60.3652 28.4808L48.0768 28.8294V34.5866L37.5622 40.5847L33.7081 50.5098L39.1826 60.1581L59.5115 84.1917L59.4246 93.8092L59.0515 95.8445C59.0515 95.8445 58.3461 104.365 63.8411 106.072C69.3361 107.779 73.4969 106.467 74.6113 104.888C75.7256 103.309 76.3645 101.248 76.155 100.089C75.9454 98.9307 75.2809 97.0236 75.2809 97.0236L74.5806 95.3421L74.7595 79.5265L74.7748 79.5367Z",
    fill: "#F0F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.1593 68.0401C90.9172 71.1212 87.5486 73.8229 83.536 75.8735C80.2976 77.5285 76.5395 77.6826 72.8089 77.8356C70.6937 77.9223 68.5873 78.0087 66.5895 78.3681L74.495 89.4669L74.6404 90.049L74.7595 79.5258L74.7748 79.536C74.7748 79.536 84.2722 79.7103 88.2848 77.6597C92.2974 75.609 95.666 72.9073 96.9081 69.8262C98.1502 66.7451 98.6614 63.5563 98.6614 63.5563V60.9674L98.2678 48.2534L97.3375 35.97C97.3375 35.97 97.3159 35.7485 97.2736 35.3682C97.1269 47.542 94.5225 62.178 92.1593 68.0401ZM75.8214 98.7308C75.7418 99.0787 75.6348 99.4087 75.4918 99.6922C74.8465 100.971 73.5208 101.393 72.2798 101.788C71.2913 102.103 70.3565 102.401 69.8624 103.101C68.9381 104.411 65.918 105.537 61.7791 104.909C62.3445 105.413 63.0243 105.818 63.8411 106.071C69.3361 107.779 73.4969 106.466 74.6113 104.887C75.7256 103.308 76.3645 101.247 76.155 100.089C76.0826 99.6888 75.9561 99.1998 75.8214 98.7308Z",
    fill: "#222838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8593 97.9208L64.3831 105.944C64.3831 105.944 69.3873 113.598 69.6122 114.029C69.8371 114.459 71.2329 118.949 71.2329 118.949C71.2329 118.949 74.0291 120.85 75.9817 113.888C77.9344 106.926 79.7639 101.643 79.0534 98.336C78.3429 95.0294 77.3819 93.8964 77.3819 93.8964L75.3015 92.2712L74.7954 92.0918C74.7954 92.0918 76.0835 94.5064 76.1193 95.7061C76.1551 96.9057 75.7922 99.8586 73.7066 100.761C71.6211 101.663 69.8832 102.007 69.8832 102.007L67.6238 102.084L65.3645 101.796L63.8566 101.32L62.3333 100.438L59.8593 97.9259V97.9208Z",
    fill: "#3477FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5423 38.0771L100.589 35.1959C100.589 35.1959 105.005 29.69 105.368 25.5733C105.731 21.4566 105.925 15.3765 102.245 9.99351C98.5646 4.61056 92.2365 2.11903 92.2365 2.11903C92.2365 2.11903 86.1843 1.20136 85.1313 1.43719C84.0783 1.67301 79.3041 2.89314 78.338 3.33916C77.3719 3.78518 73.7171 6.08703 73.7171 6.08703L71.2737 8.5478C71.2737 8.5478 66.065 5.62563 64.2043 5.36417C62.3437 5.10272 56.5267 4.46189 51.1391 6.10753C45.7514 7.75318 37.8795 11.1111 35.9013 13.049C33.9231 14.9868 26.6748 21.2721 26.363 28.7262C26.0512 36.1803 26.133 39.2972 26.133 39.2972C26.133 39.2972 27.6716 48.1048 23.2041 53.4672C18.7365 58.8296 18.3531 63.4641 18.3531 63.4641C18.3531 63.4641 18.5576 70.9746 21.3843 73.5738C24.211 76.173 29.7572 80.6639 36.1416 82.571C42.526 84.4781 52.0387 86.0622 52.0387 86.0622L54.9574 86.3288L59.6448 86.6825V75.1528C59.6448 75.1528 57.9273 75.0759 56.2047 73.9224C54.482 72.7689 51.5889 69.7032 51.1748 68.8368C50.7608 67.9704 50.1474 66.1556 50.1474 66.1556L49.7436 63.623L49.6209 61.6852C49.6209 61.6852 45.6594 60.9572 42.8327 58.6195C40.0059 56.2817 37.9 53.985 37.9 53.985L36.8879 52.283C36.8879 52.283 35.9627 48.4636 36.1518 47.7562C36.3409 47.0487 37.4655 43.742 38.1913 43.0192C38.9172 42.2963 40.3893 40.9993 41.3963 40.8404C42.4033 40.6814 44.0186 40.6814 44.407 40.7481C44.7955 40.8147 47.0038 41.5735 47.0038 41.5735L48.9253 42.9231C49.588 43.3885 50.5001 42.9145 50.5001 42.1048V29.2286C50.5001 29.2286 55.4737 30.0745 59.6448 29.7822C63.8159 29.49 70.1696 29.7361 74.7752 26.4243C79.3807 23.1125 80.7251 20.38 81.0573 19.2163C81.3896 18.0525 81.635 14.6331 81.635 14.6331C81.635 14.6331 88.3721 17.2477 91.9604 21.7591C95.5488 26.2705 97.1794 31.9867 97.1794 31.9867L97.3021 35.3549L97.5577 38.0515L97.5423 38.0771Z",
    fill: "#222838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.859 83.6934C59.859 83.6934 58.1721 83.6062 57.4003 83.7549C56.6284 83.9035 55.2023 84.4111 54.7627 84.8161C54.3231 85.2211 53.2292 86.067 53.2241 87.1077C53.219 88.1484 52.6465 90.3067 52.6465 90.3067L52.2324 93.5826C52.2324 93.5826 45.71 94.977 44.0896 95.705C42.4692 96.433 35.9519 98.2119 32.7827 100.375C29.6135 102.539 28.5349 104.779 28.5349 104.779L26.6999 108.301L25.468 112.269C25.468 112.269 24.7421 116.376 24.645 117.642C24.5479 118.908 24.645 121.559 24.645 121.559L24.3383 124.645V128.772L23.9601 133.806L23.6227 139.384L23.4898 141.219L22.9633 146.997L22.0023 153.979C22.0023 153.979 16.7271 172.814 16.5073 173.466C16.2875 174.117 32.2664 172.958 32.2664 172.958L42.7452 141.224C42.7452 141.224 44.2481 142.244 44.8103 142.86C45.3726 143.475 47.3559 145.11 47.1361 147.304C46.9163 149.499 45.2806 152.8 43.7369 154.615C42.1932 156.43 38.3084 161.474 37.925 162.095C37.5416 162.715 34.2344 167.457 33.9226 170.897C33.6108 174.337 32.4453 178.459 32.4453 178.459L110.464 177.7C110.464 177.7 104.78 155.574 103.553 146.628C102.326 137.682 101.278 126.501 100.951 118.765C100.624 111.028 100.425 101.775 97.9763 98.74C95.5278 95.705 93.979 94.2696 92.3177 93.9004C90.6565 93.5313 86.6438 92.6137 86.6438 92.6137L83.1219 92.0959C83.1219 92.0959 82.4216 89.5479 81.6293 88.3278C80.837 87.1077 78.9304 85.2467 77.6781 84.9391C76.4257 84.6315 74.8718 84.5444 74.8718 84.5444L74.7951 92.0959C74.7951 92.0959 75.9145 92.8597 76.9471 93.9004C77.9796 94.9411 79.5796 97.9812 79.0991 101.134C78.6186 104.287 76.1632 112.248 74.9391 116.242C74.2009 118.651 71.2329 118.948 71.2329 118.948C71.2329 118.948 71.3218 118.237 70.9563 117.334C69.617 114.028 67.2708 109.88 66.4785 108.911C65.6862 107.942 60.1299 99.7038 59.5983 97.0892C59.0667 94.4746 59.0718 91.0808 59.0718 91.0808L59.4449 89.0455L59.8641 84.329V83.6934H59.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2442 75.2196C59.2442 75.2196 49.2305 72.8665 49.7008 61.7264C45.7751 60.6601 44.6556 60.2807 40.6277 56.8612C36.5997 53.4418 35.1429 49.9044 36.8911 44.9931C37.4125 43.5269 39.6053 41.2507 41.3791 40.8611C43.6742 40.3535 46.0767 40.8867 48.0344 42.1991L48.931 42.8004C49.5953 43.246 50.488 42.7699 50.488 41.9699V29.2544C50.488 29.2544 53.7748 30.6642 66.4465 29.2544C83.3404 26.2707 81.6229 14.6641 81.6229 14.6641C81.6229 14.6641 95.5469 20.0009 96.9526 32.2381C98.3583 44.4753 99.1404 62.3621 98.3583 65.9712C97.5762 69.5804 93.5074 79.6234 77.7073 79.6234C71.1389 79.6234 66.4413 78.5263 66.4413 78.5263",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4359 63.2908C71.1106 63.0088 68.5836 60.0303 68.5836 60.0303",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8336 37.0525C102.018 34.0329 109.568 25.0306 103.342 12.0397C95.6133 -4.10911 76.9048 1.11491 71.2667 8.55363C66.5129 5.22645 63.4817 5.06753 58.6819 4.91373C56.6883 4.84708 25.6966 7.92305 26.0135 33.5613C26.0135 45.9061 27.593 48.1208 22.5427 54.2984C17.4924 60.476 11.1796 75.1894 40.5305 84.0533C46.0586 85.3334 50.3773 85.9425 53.4578 86.225",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6275 75.3008L59.5712 88.6514C59.5712 88.6514 57.0921 94.7213 62.0504 102.422C67.0087 110.127 71.0877 114.951 71.1388 118.657",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7737 81.9189V92.0925",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2467 93.3838C52.2467 93.3838 35.4193 97.3159 30.9722 101.776C26.5251 106.236 24.6491 112.342 24.414 121.739C24.1788 131.136 23.4734 148.51 21.3674 156.969C19.2615 165.428 14.3441 181.392 11.0675 186.56",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.926 183.746C106.133 169.888 102.621 141.236 101.451 130.198C100.469 120.939 101.793 106.072 97.9645 98.7412C97.7969 98.4179 97.6197 98.1096 97.4317 97.8174",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1155 92.0918C87.3325 92.5891 92.2448 93.5683 95.1329 95.4344C95.2658 95.5215 95.3936 95.6087 95.5162 95.7061",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8514 83.72C58.8514 83.72 53.7654 83.074 52.9731 88.1493C52.2001 93.1011 51.0962 99.834 53.4497 105.044C53.5623 105.293 53.7798 105.482 54.0464 105.543C56.5941 106.122 58.6981 104.626 58.6981 104.626L57.8203 109.362C57.7288 109.855 58.0143 110.343 58.4793 110.532C60.0873 111.187 63.6729 112.902 65.6499 115.843",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8654 84.5353C74.8654 84.5353 80.4064 84.0432 82.175 89.6671C83.5793 94.1324 85.5668 99.3475 86.3261 101.307C86.5048 101.768 86.3214 102.288 85.894 102.537L81.929 104.842C81.4767 105.105 81.3036 105.672 81.5319 106.143L83.0373 109.247C83.2067 109.597 83.1586 110.012 82.9141 110.314L73.976 121.329C73.976 121.329 75.5657 151.822 76.1126 187.58",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7887 92.0918C74.7887 92.0918 76.8947 92.3481 78.7298 96.9108C80.5648 101.474 74.7887 117.079 74.7887 117.079",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1285 189.595C27.1285 189.595 35.4621 165.73 43.3391 143.163L44.1295 122.664",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0662 94.4808C59.0662 94.4808 59.6285 100.756 65.6449 101.853C72.2747 103.063 79.1805 99.7715 74.7896 92.0918",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1955 114.033C90.1955 114.033 94.5558 121.687 93.6868 130.438C92.8178 139.19 88.6723 146.628 88.6723 146.628C88.6723 146.628 104.59 147.828 103.067 197.151",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.331 45.1934C78.331 45.1934 81.0359 47.7478 82.9995 49.4827C83.8043 50.1937 83.9576 51.4104 83.1835 52.1546C81.8265 53.4592 79.4743 55.1851 76.5266 55.1851",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7723 131.392C55.4461 131.392 53.5603 129.023 53.5603 126.101C53.5603 123.179 55.4461 120.811 57.7723 120.811",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7782 131.392H59.2708C61.5965 131.392 63.4827 129.023 63.4827 126.101C63.4827 125.836 63.4671 125.574 63.4367 125.318",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0272 90.5898C37.4846 99.6332 57.7727 120.811 57.7727 120.811H59.2652C60.7067 120.811 61.9846 121.724 62.7411 123.113",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7714 129.259C59.1604 129.259 60.2863 127.845 60.2863 126.101C60.2863 124.357 59.1604 122.943 57.7714 122.943",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6032 103.288C84.6032 103.288 87.2817 110.414 84.3374 122.944",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8785 137.795C78.8785 137.795 73.232 120.729 83.6272 123.118C94.0224 125.507 85.1709 137.939 85.1709 137.939",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4766 47.1317C63.4766 47.1317 66.0375 42.8254 71.2616 45.9167",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7107 45.901C92.7107 45.901 89.4188 42.1278 84.8337 46.1061",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3605 30.8696C69.3605 30.8696 64.0444 30.2902 61.9844 33.1868",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1247 30.7525C85.1247 30.7525 89.7558 29.0095 92.2298 31.7163",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 45.9682C47.6006 45.9682 40.1428 39.9649 39.192 50.5104",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.542 56.6621C73.9481 56.6621 78.3307 51.5276 78.3307 45.1938C78.3307 38.8601 73.9481 33.7256 68.542 33.7256C63.1358 33.7256 58.7532 38.8601 58.7532 45.1938C58.7532 51.5276 63.1358 56.6621 68.542 56.6621Z",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8035 49.3102C82.3843 48.0337 82.1543 46.6444 82.1543 45.1987C82.1543 38.8673 86.535 33.7305 91.9431 33.7305C97.3512 33.7305 101.732 38.8673 101.732 45.1987C101.732 51.5301 97.3512 56.6669 91.9431 56.6669C88.5643 56.6669 85.5842 54.6624 83.8258 51.6121",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4792 45.5249L49.6798 43.291",
    stroke: "#222838",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.49bd015015dab39c144d5fb21b243b5e.svg";
export { ForwardRef as ReactComponent };